import { Inbox } from "lucide-react";
import { GlossyBadge } from "./GlossyBadge";

export function EmptyState({ icon = Inbox, title, hint, testid, compact = false }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-2 text-center ${compact ? "py-4" : "py-8"}`} data-testid={testid}>
      <GlossyBadge icon={icon} size={compact ? 40 : 48} tone="navy" />
      <div className="text-sm font-medium text-slate-600">{title}</div>
      {hint && <div className="max-w-xs text-xs text-slate-400">{hint}</div>}
    </div>
  );
}
